module.exports = new __parcel__URL__("delivery.bedaad69.svg").toString();